export const STM_ELIGIBLE = 'STM: STM eligible'
export const STM_INELIGIBLE = 'Non-served: STM ineligible'
